import { render, staticRenderFns } from "./BesarPenyakitRajal.vue?vue&type=template&id=bbfdb86a"
import script from "./BesarPenyakitRajal.vue?vue&type=script&lang=js"
export * from "./BesarPenyakitRajal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbfdb86a')) {
      api.createRecord('bbfdb86a', component.options)
    } else {
      api.reload('bbfdb86a', component.options)
    }
    module.hot.accept("./BesarPenyakitRajal.vue?vue&type=template&id=bbfdb86a", function () {
      api.rerender('bbfdb86a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/morbiditas-rajal/BesarPenyakitRajal.vue"
export default component.exports